import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout.vue"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/pages/Dashboard"),
        },
        {
          path: "/projects",
          name: "projects",
          component: () => import("@/view/pages/Projects"),
        },
        {
          path: "/paths",
          name: "all-paths",
          component: () => import("@/view/pages/Paths"),
        },
        {
          path: "/teams",
          name: "teams",
          component: () => import("@/view/pages/Team"),
        },
        {
          path: "/ranking",
          name: "ranking",
          component: () => import("@/view/pages/Ranking"),
        },
        {
          path: "/about",
          name: "about",
          component: () => import("@/view/pages/About.vue"),
        },
        {
          path: "/forums",
          name: "forums",
          component: () => import("@/view/pages/Forums.vue"),
        },
        {
          path: "/forums/:forumId",
          name: "forum",
          component: () => import("@/view/pages/Forum-single.vue"),
        },
        {
          path: "/forums/add/:tagId",
          name: "forums-add",
          component: () => import("@/view/pages/Forum-add.vue"),
        },
        {
          path: "/videoblog",
          name: "tutorials",
          component: () => import("@/view/pages/Tutorials.vue"),
        },
        {
          path: "/videoblog/add/:tutorialId",
          name: "tutorial-add",
          component: () => import("@/view/pages/Tutorial-add.vue"),
        },
        {
          path: "/videoblog/:tutorialId",
          name: "tutorial-single",
          component: () => import("@/view/pages/Tutorial-single.vue"),
        },

        {
          path: "/profile/:usersId",
          name: "profile",
          component: () => import("@/view/pages/Profile.vue"),
        },
        {
          path: "/projects/:projectId",
          name: "project-single",
          component: () => import("@/view/pages/Project-single.vue"),
        },
        {
          path: "/instance/:projectId",
          name: "instance-single",
          component: () => import("@/view/pages/Instance-single.vue"),
        },
        {
          path: "/teams/:teamId",
          name: "teams-single",
          component: () => import("@/view/pages/Team-single.vue"),
        },
      ],
    },
    {
      path: "/backend",
      redirect: "/backend/students",
      component: () => import("@/view/pages/Backend"),
      children: [
        {
          path: "students",
          name: "students",
          component: () => import("@/view/pages/Backend/Students"),
        },
        {
          path: "students/create",
          name: "students-create",
          component: () => import("@/view/pages/Backend/Students-create"),
        },
        {
          path: "students/:studentId",
          name: "studentId",
          component: () => import("@/view/pages/Backend/Students-single"),
        },
        {
          path: "projects",
          name: "allprojects",
          component: () => import("@/view/pages/Backend/Projects"),
        },
        {
          path: "projects/create",
          name: "projects-create",
          component: () => import("@/view/pages/Backend/Projects-create"),
        },
        {
          path: "projects/:projectId",
          name: "projects-single",
          component: () => import("@/view/pages/Backend/Projects-single"),
        },
        {
          path: "projects/:projectId/sections",
          name: "sections",
          component: () => import("@/view/pages/Backend/Projects/Sections"),
        },
        {
          path: "paths",
          name: "paths",
          component: () => import("@/view/pages/Backend/Paths"),
        },
        {
          path: "instances",
          name: "instances",
          component: () => import("@/view/pages/Backend/Instances"),
        },
        {
          path: "sessions",
          name: "sessions",
          component: () => import("@/view/pages/Backend/Sessions"),
        },

        {
          path: "tags",
          name: "tags",
          component: () => import("@/view/pages/Backend/Tags"),
        },
        {
          path: "deadlines",
          name: "deadlines",
          component: () => import("@/view/pages/Backend/Deadlines"),
        },
        {
          path: "profiles",
          name: "profiles",
          component: () => import("@/view/pages/Backend/Profiles"),
        },
        {
          path: "outcomes",
          name: "outcomes",
          component: () => import("@/view/pages/Backend/Outcomes"),
        },
        {
          path: "roles",
          name: "roles",
          component: () => import("@/view/pages/Backend/Roles"),
        },
        {
          path: "levels",
          name: "levels",
          component: () => import("@/view/pages/Backend/Levels"),
        },
        {
          path: "teams",
          name: "_teams",
          component: () => import("@/view/pages/Backend/Teams"),
        },
        {
          path: "challenges",
          name: "challenges",
          component: () => import("@/view/pages/Backend/Challenges"),
        },
      ],
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login"),
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Register"),
        },
        {
          name: "forgot",
          path: "/forgot",
          component: () => import("@/view/pages/auth/Forgot"),
        },
        {
          name: "recover",
          path: "/recover",
          component: () => import("@/view/pages/auth/Recover"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/404/Error.vue"),
    },
  ],
});
